import { render } from "./BookingCalendar.vue?vue&type=template&id=23cfe145&scoped=true&ts=true"
import script from "./BookingCalendar.vue?vue&type=script&lang=ts"
export * from "./BookingCalendar.vue?vue&type=script&lang=ts"

import "./BookingCalendar.vue?vue&type=style&index=0&id=23cfe145&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cfe145"]])

export default __exports__